var exports = {
  "k": "xdde3148b--55284d--container",
  "Q": "xdde3148b--55284d--content",
};

module.exports = exports;
